import { useState } from "react";
import "@/App.css";
import { Toaster, toast } from "sonner";
import Sidebar from "./components/Sidebar";
import Pocetna from "./components/Pocetna";
import Editor from "./components/Editor";
import Arhiva from "./components/Arhiva";
import Postavke from "./components/Postavke";
import { loadSettings, loadRecords, newRecord, findTodayRecord, exampleRecord, saveRecord } from "./lib/storage";

export default function App() {
  const [settings, setSettings] = useState(loadSettings);
  const [records, setRecords] = useState(loadRecords);
  const [view, setView] = useState("pocetna");
  const [current, setCurrent] = useState(null);

  const refresh = () => {
    setRecords(loadRecords());
    setSettings(loadSettings());
  };

  const openMode = (mode) => {
    if (mode === "nastavni" || mode === "nenastavni") {
      const existing = findTodayRecord(mode);
      if (existing) {
        setCurrent(existing);
        toast.info("Nastavljate današnju evidenciju");
      } else {
        setCurrent(newRecord(mode));
      }
      setView(mode);
    } else {
      setCurrent(null);
      setView(mode);
    }
  };

  const editRecord = (r) => {
    setCurrent(r);
    setView(r.tip);
  };

  const loadExample = () => {
    const ex = exampleRecord();
    saveRecord(ex);
    refresh();
    setCurrent(ex);
    setView("nastavni");
    toast.info("Učitan je ogledni primjer ispunjene evidencije");
  };

  const backHome = () => {
    refresh();
    setCurrent(null);
    setView("pocetna");
  };

  const activeNav = view === "nastavni" || view === "nenastavni" ? view : view;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 antialiased selection:bg-sky-100 selection:text-sky-900">
      <Toaster position="bottom-right" richColors />
      <div className="flex min-h-screen flex-col lg:flex-row">
        <Sidebar active={activeNav} onSelect={openMode} onDataChanged={refresh} schoolName={settings.nazivSkole} />
        <main className="mx-auto w-full max-w-6xl flex-1 p-4 sm:p-6 lg:p-8">
          {view === "pocetna" && <Pocetna settings={settings} onSelect={openMode} recordCount={records.length} onLoadExample={loadExample} />}
          {(view === "nastavni" || view === "nenastavni") && current && (
            <Editor key={current.id} initialRecord={current} settings={settings} onBack={backHome} />
          )}
          {view === "arhiva" && <Arhiva records={records} settings={settings} onEdit={editRecord} onDataChanged={refresh} />}
          {view === "postavke" && <Postavke settings={settings} onSave={setSettings} />}
        </main>
      </div>
    </div>
  );
}
